module.exports = "/packs/media/images/module-social-small-primary-62ee77bd9efc923d24ad87d011723a14.png";